import { VF_BUTTON_SELECTOR } from 'AppSrc/core/components/forms/form-base-components/v-f-button-selector';
import {
  INLINE_ERRORS,
  commonValidation,
  cleanUpFieldErrors,
  getDefaultFieldErrors,
} from 'AppSrc/core/components/forms/form-base-components/utility/common-validation';
import {
  r5Yes,
  r5No,
} from 'AppSrc/core/components/forms/value-dependency-constants';

const fieldId = 'is-regression-possible';

const validator = (params) => {
  const {
    values,
    field,
  } = params;
  const {
    optional,
  } = field;

  /* MAKE A DEFAULT ERRORS OBJECT */
  const errors = getDefaultFieldErrors();

  /* ERROR CHECKERS */
  const noValue = commonValidation.noValue(values[fieldId], VF_BUTTON_SELECTOR);

  /* ADD ERRORS TO ERROR OBJECT */
  errors[INLINE_ERRORS].push((noValue && !optional) ? 'Please select an answer' : null);

  /* REMOVE BLANK ERRORS (because Formik gets confused) */
  return cleanUpFieldErrors(errors);
};


const initialValues = [];

const vFParams = {
  multiSelect: false,
  fieldTitle: 'Is regression possible?',
};

const riskLevelParams = {
  weight: 0.2,
  score: {
    [r5Yes]: 1,
    [r5No]: 4,
  },
};

const isRegressionPossible = {
  id: fieldId,
  validator,
  initialValues,
  vFParams,
  riskLevelParams,
  fieldType: VF_BUTTON_SELECTOR,
};

export { isRegressionPossible };
